import { RouteProps } from 'react-router-dom';
import HomePage from '../container/Home/Home.page';
import BillerPage from '../container/Biller/Biller.page';
import ServicesPage from '../container/Services/Services.page';
import TNCPage from '../container/TNC/TNC.page';
import NotFoundPage from '../container/404/404.page';

export interface IRoute extends RouteProps {
  key: number;
  path: string;
  exact: boolean;
  element: any;
}

const Routes: Array<IRoute> = [
  {
    key: 0,
    path: '/',
    exact: true,
    element: HomePage,
  },
  {
    key: 1,
    path: '/services/:serviceId',
    exact: true,
    element: ServicesPage,
  },
  {
    key: 2,
    path: '/biller/:billerGroupId',
    exact: true,
    element: BillerPage,
  },
  {
    key: 3,
    path: '/tnc',
    exact: true,
    element: TNCPage,
  },
  {
    key: 99,
    path: '*',
    exact: true,
    element: NotFoundPage,
  },
];

export default Routes;
